// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {CanvasAnchor} from './canvas-anchor.js'
import {Id} from './id.js'
import {SetBool} from './set-bool.js'
import {SetString} from './set-string.js'

export class ModifyComment {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifyComment {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsModifyComment(bb: flatbuffers.ByteBuffer, obj?: ModifyComment): ModifyComment {
    return (obj || new ModifyComment()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsModifyComment(bb: flatbuffers.ByteBuffer, obj?: ModifyComment): ModifyComment {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ModifyComment()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  comment(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  anchor(obj?: CanvasAnchor): CanvasAnchor | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new CanvasAnchor()).__init(this.bb_pos + offset, this.bb!) : null
  }

  text(obj?: SetString): SetString | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new SetString()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  resolved(obj?: SetBool): SetBool | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new SetBool()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  static startModifyComment(builder: flatbuffers.Builder) {
    builder.startObject(4)
  }

  static addComment(builder: flatbuffers.Builder, commentOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, commentOffset, 0)
  }

  static addAnchor(builder: flatbuffers.Builder, anchorOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, anchorOffset, 0)
  }

  static addText(builder: flatbuffers.Builder, textOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, textOffset, 0)
  }

  static addResolved(builder: flatbuffers.Builder, resolvedOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, resolvedOffset, 0)
  }

  static endModifyComment(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // comment
    return offset
  }
}
